<template>
  <onboarding-step :validate="validate">
    <template #heading>
      Is it important for you to work in a <span class="whitespace-nowrap">high-prestige</span> job?
    </template>
    <template #subheading>
      This includes associate positions at America's largest firms, federal clerkships, and competitive public service positions.
    </template>
    <template #content>
      <div class="space-y-3">
        <l-radio-select
          v-model="user.report.national"
          class="label:sr-only"
          label="Is it important for you to work in a high-prestige job?"
          :items="[[true, 'Yes'],[false, 'No']]"
        />
      </div>
    </template>
    <template #subcontent>
      <img src="/images/illustration-sitting.svg" class="h-full w-auto py-16">
    </template>
  </onboarding-step>
</template>

<script setup>
import LRadioSelect from "@/components/inputs/LRadioSelect.vue"
import OnboardingStep from "@/components/onboardings/OnboardingStep.vue"

const user = defineModel({ type: Object, required: true })

const validate = () => {
  if (user.value.report.national === true || user.value.report.national === false) {
    return
  }

  return "Please select an option."
}
</script>
